import { lazy } from 'react';
import { authRoleAccess } from '../../auth/AuthRoleAccess';

const SettingsHub = lazy(() => import('./SettingsHub'));
const KitchenSettings = lazy(() => import('./KitchenSettings'));
const ServiceSettings = lazy(() => import('./ServiceSettings'));
const PromotionsSettings = lazy(() => import('./PromotionsSettings'));
const CompanySettings = lazy(() => import('./CompanySettings'));
const CompanyConfigurationSettings = lazy(() => import('./CompanyConfigurationSettings'));
const UnifiedMenuSetup = lazy(() => import('../DataSetup/UnifiedMenuSetup'));
const UserManagementSettings = lazy(() => import('./UserManagementSettings'));
const GuestPortalSettings = lazy(() => import('./GuestPortalSettings'));
// const MenuDataSetup = lazy(() => import('../DataSetup/MenuDataSetup')); // Kept for reference

export const SettingsRoutes = [
    {
        path: '/settings',
        component: SettingsHub,
        auth: authRoleAccess.settings,
    },
    {
        path: '/settings/menu',
        component: UnifiedMenuSetup,
        auth: authRoleAccess.settings,
    },
    {
        path: '/settings/kitchen',
        component: KitchenSettings,
        auth: authRoleAccess.settings,
    },
    {
        path: '/settings/service',
        component: ServiceSettings,
        auth: authRoleAccess.settings,
    },
    {
        path: '/settings/promotions',
        component: PromotionsSettings,
        auth: authRoleAccess.settings,
    },
    {
        path: '/settings/configuration',
        component: CompanyConfigurationSettings,
        auth: authRoleAccess.settings,
    },
    {
        path: '/settings/company',
        component: CompanySettings,
        auth: authRoleAccess.settings,
    },
    {
        path: '/settings/users',
        component: UserManagementSettings,
        auth: authRoleAccess.settings,
    },
    {
        path: '/settings/guest-portal',
        component: GuestPortalSettings,
        auth: authRoleAccess.settings,
    },
];

export default SettingsRoutes;
